import React from 'react';

function Banner(props) {
    const { resources, selectBanner } = props;

    return (
        <div className='banner-selection-backdrop'
             onClick={selectBanner}>
            <div className='banner-selection-header'>
                Please select a banner:
            </div>
            <div className='banner-selection-body'>
                {
                    resources.map((resource, index) =>
                        (resource.isVideoFile ?
                            (resource.placeholderImageFilename ?
                                <div
                                    key={`video-placeholder-image-` + index}
                                    className='banner-selection-item image-item'
                                    style={{ backgroundImage: "url(https://images.dynamify.com/order-status-logos/" + resource.placeholderImageFilename + ")" }}
                                    onClick={() => selectBanner(resource)}>
                                </div>
                                :
                                <div
                                    key={`video-` + index}
                                    className='banner-selection-item video-item'
                                    onClick={() => selectBanner(resource)}>
                                    <video id="banner-video" playsInline muted
                                           preload="false"
                                           type="video/mp4">
                                        <source type="video/mp4"
                                                src={'https://images.dynamify.com/order-status-logos/' + resource.fileName} />
                                    </video>
                                </div>
                            )
                            :
                            <div
                                key={`image-` + index}
                                className='banner-selection-item image-item'
                                style={{ backgroundImage: "url(https://images.dynamify.com/order-status-logos/" + resource.fileName + ")" }}
                                onClick={() => selectBanner(resource)}>
                            </div>
                        )
                    )
                }
            </div>
        </div>
    );
}

export default Banner;
